import { useNavigate } from 'react-router-dom';
import { Button, Description, Heading } from '@heroui/react';
import { AuthSplitLayout } from '../../auth/components/auth-split-layout';
import { useAuth } from '../../../hooks/useAuth';
import { defaultAppRoute } from '../../../shell/nav-items';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { userDoc, loading } = useAuth();
  const isSignedIn = !loading && !!userDoc;
  const homeTo = isSignedIn ? defaultAppRoute : '/login';

  return (
    <AuthSplitLayout>
      <div className="w-full max-w-sm space-y-6">
        <div className="flex w-full flex-col items-center space-y-1 text-center lg:items-start lg:text-left">
          <Heading level={2} className="w-full text-center text-2xl font-semibold lg:text-left">
            Página não encontrada
          </Heading>
          <Description className="text-center lg:text-left">
            O endereço que você acessou não existe ou não está disponível.
          </Description>
        </div>

        <Button
          variant="primary"
          size="lg"
          fullWidth
          onPress={() => navigate(homeTo)}
        >
          {isSignedIn ? 'Ir para o início' : 'Fazer login'}
        </Button>
      </div>
    </AuthSplitLayout>
  );
}
